import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationModulesResponse } from './application-modules.models';
import { EndpointConstants } from 'src/app/core/services/endpoints-configurations/endpoint-constants';
import { HttpClientRequestService } from '@core/request-services/httpclient.request.services';
import { IApplicationModules } from '@core/models/admin/application/applicationmodules.model';

@Injectable({ providedIn: 'root' })
export class ApplicationModulesStoreService {
  constructor(private repo: HttpClientRequestService) {}

  getApplicationModules(request: IApplicationModules): Observable<ApplicationModulesResponse> {
    const url: string = EndpointConstants.ApiApplicationmodules;
    return this.repo.post(url, request);
  }
}
